import { 
	GET_PROJECT_STATUSES, 
	GET_PROJECT_STATUS,
	CREATE_PROJECT_STATUS,
	UPDATE_PROJECT_STATUS,
	DESTROY_PROJECT_STATUS,
} from "./actions"

export function ProjectStatusesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_STATUSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_STATUS}_FULFILLED`:
		case `${CREATE_PROJECT_STATUS}_FULFILLED`:
		case `${UPDATE_PROJECT_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectStatusesReducer } from "modules/project/statuses/reducer"

// project_statuses:ProjectStatusesReducer,
